import InputOutlet from 'components/inputOutlet';
import SelectOutlet from 'components/selectOutlet';
import {useFormik} from 'formik';
import CustomButton from 'modules/auth/login/components/customButton';
import {account_types} from 'modules/profile/editProfile/utilities';
import {useLocation} from 'react-router-dom';
import {CityType} from 'utilities/hooks/getStates/type';
import useGetStates from 'utilities/hooks/getStates/useGetStates';
import UseSignUp from './hooks/useSignUp';
import {initialValues} from './utilities/initialValues';
import {signUpSchema} from './utilities/validation';

const SignUp = () => {
  const {
    state: {mobile, code},
  } = useLocation();

  const {statesIran} = useGetStates();
  const {isLoading, mutate} = UseSignUp();

  const formik = useFormik<ISignUpCommand>({
    initialValues,
    validationSchema: signUpSchema,
    onSubmit: values => {
      mutate({
        account_type: values.account_type,
        code,
        phone_number: mobile,
        name: values.fullName,
        email: String(values.email),
        country: values.country,
        country_code: '98',
        city: Number(values.city),
        state: Number(values.province),
        app: 'market',
      });
    },
  });

  return (
    <div>
      <form
        onSubmit={formik.handleSubmit}
        className="flex flex-col gap-4 -mx-6 "
      >
        <InputOutlet
          label="نام و نام خانوادگی"
          name="fullName"
          value={formik.values.fullName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errors={formik.errors.fullName}
          touched={formik.touched.fullName}
          required
        />

        <InputOutlet
          label="ایمیل (اختیاری)"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errors={formik.errors.email}
          touched={formik.touched.email}
        />

        <SelectOutlet
          label="کشور"
          name="country"
          type="string"
          value={formik.values.country}
          disabled={true}
          required
          options={[
            {
              label: 'ایران',
              value: 'ایران',
            },
          ]}
        />

        <SelectOutlet
          name="province"
          label="استان"
          value={formik.values.province}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          options={
            (statesIran?.length &&
              statesIran.map(item => ({
                value: item.id,
                label: item.name,
              }))) ||
            []
          }
          errors={formik.errors.province}
          touched={formik.touched.province}
          required
        />

        <SelectOutlet
          name="city"
          label="شهرستان"
          value={formik.values.city}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          options={
            (formik.values.province &&
              statesIran
                ?.find(item => item.id === +formik.values.province)
                ?.cities?.map((city: CityType) => ({
                  value: city.id,
                  label: city.name,
                }))) ||
            []
          }
          errors={formik.errors.city}
          touched={formik.touched.city}
          disabled={!formik.values.province}
          required
        />

        <SelectOutlet
          name="account_type"
          label="نقش کاربری"
          value={formik.values.account_type}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          options={account_types}
          errors={formik.errors.account_type}
          touched={formik.touched.account_type}
          required
        />

        <CustomButton
          title="عضویت"
          disabled={isLoading || !formik.isValid || !formik.dirty}
        />
      </form>
    </div>
  );
};

export default SignUp;
